import React, {Component} from "react"
import {Entity} from 'aframe-react'

// import SearchImage from '../assets/icons/search-img.png'
import MicImage from "../assets/icons/mic.png"

import fixed from "../components-aframe/fixed"

import OpenSans from "../assets/fonts/roboto.fnt"
import OpenSansSheet from "../assets/fonts/roboto.png"

import Quicksand from "../assets/fonts/quicksandmedium.fnt"
import QuicksandSheet from "../assets/fonts/quicksandmedium.png"

class SearchInput extends Component {

    render() {

        let text = (this.props.text.length > 0) ? this.props.text : "Say what you want to visualize"
        return (
            <Entity position={{x: 0, y: 0, z: 0}} fixed>

                <Entity position={{x:0, y: -0.15, z: -5}}>

                    <Entity
                        primitive="a-image"

                        material={{
                            transparent: true
                        }}

                        src={MicImage}

                        width={50}
                        height={89}

                        position={{
                            x: 0,
                            y: 0.5,
                            z: 0
                        }}

                        scale="0.005 0.005 1"
                    />

                    <Entity
                        primitive="a-text"
                        value={text}

                        // color="#282828"
                        color="#F5F5F5"

                        text={{
                            font: OpenSans, //Quicksand,
                            fontImage: OpenSansSheet, //QuicksandSheet,
                            // wrapCount: 20,
                        }}

                        align="center"
                    ></Entity>

                </Entity>




            </Entity>
        );
    }
}

export default SearchInput;



// WEBPACK FOOTER //
// ./src/components/search-input.js